import { render, staticRenderFns } from "./FieldsGender.vue?vue&type=template&id=3736bc79&"
import script from "./FieldsGender.vue?vue&type=script&lang=js&"
export * from "./FieldsGender.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports